import { apiContainer } from '@vlabs/api-bindings';
import { getSimilarityThresholds } from '@vlabs/shared/config/similarityThresholds';

import { getGroupedMatchesByListsAndExternalId } from '../requests/getGroupedMatchesByListsAndExternalId';
import type { GetGroupedMatchesReturn, BuildMatchListProps } from '../types';

export const buildMatchList = async ({
  formValues,
  detections,
  sampleId,
}: BuildMatchListProps): Promise<GetGroupedMatchesReturn> => {
  const similarityThresholds = getSimilarityThresholds();

  const candidates = [];
  const references = detections.filter(({ id }) => id === sampleId[0]).map(({ sdk_descriptor, id }) => ({
    data: sdk_descriptor, type: 'sdk_descriptor', id,
  }));

  let uiDetectionURL = '';

  const detection = detections.find((d) => d.id === sampleId[0]);
  if (detection) {
    uiDetectionURL = detection.uiDetectionUrl;
  }

  if (formValues?.external_id) {
    candidates.push({
      filters: { origin: 'faces', external_ids: formValues.external_id },
      limit: 1,
    });
  }

  if (Array.isArray(formValues?.lists) && formValues?.lists?.length > 0) {
    formValues.lists.forEach(({ value }) => candidates.push({
      filters: { origin: 'faces', list_id: { value } },
      limit: 1,
      threshold: similarityThresholds.medium,
    }));
  }

  const [{ matches }] = await apiContainer.lunaClient.matcher.faces({ references, candidates });

  return getGroupedMatchesByListsAndExternalId({ matches, uiDetectionURL });
};
